import {FormControlLabel, FormGroup, Switch, useTheme} from "@mui/material";

const CustomSwitch = ({
                          label,
                          value,
                          handleChange,
                          readOnly
                      }: { label: string, value: boolean, handleChange: Function, readOnly: boolean }) => {

    // Use Theme
    const theme = useTheme();

    return (
        <FormGroup sx={{
            height: "100%"
        }}>
            <FormControlLabel
                control={<Switch/>}
                label={label}
                checked={value}
                disabled={readOnly}
                sx={{
                    color: theme.palette.accent.main,
                    height: "100%",
                    marginLeft: "0",
                    columnGap: 1,
                    alignItems: "center",
                    justifyContent: "flex-start"
                }}
                onChange={(event, checked) => handleChange(checked)}
            />
        </FormGroup>
    );
};

export default CustomSwitch;